import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { InquiryForm } from "./InquiryForm";
import { Button } from "./ui/button";
import { Phone, Mail, MapPin, Instagram, Facebook, Youtube, Clock } from "lucide-react";

export function Footer() {
  const { t } = useI18n();
  const [site, setSite] = useState({});
  useEffect(() => { api.get("/site").then(({ data }) => setSite(data)).catch(() => {}); }, []);

  return (
    <footer className="bg-navy text-cream/90 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <div className="h-10 w-10 rounded-2xl bg-coral flex items-center justify-center text-white font-heading font-bold text-lg">A</div>
            <span className="font-heading font-bold text-xl text-white">Ainalem</span>
          </div>
          <p className="text-sm text-cream/70 leading-relaxed">{t.hero.subtitle}</p>
          <div className="flex gap-3 mt-5">
            {[[Instagram, site?.socials?.instagram], [Facebook, site?.socials?.facebook], [Youtube, site?.socials?.youtube]].map(([Icon, url], i) => (
              <a key={i} href={url || "#"} target="_blank" rel="noreferrer" data-testid={`footer-social-${i}`}
                className="h-9 w-9 rounded-full bg-white/10 hover:bg-coral flex items-center justify-center transition-colors">
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/programs" className="hover:text-mustard transition-colors">{t.nav.programs}</Link></li>
            <li><Link to="/summer-camp" className="hover:text-mustard transition-colors">{t.nav.summer}</Link></li>
            <li><Link to="/gallery" className="hover:text-mustard transition-colors">{t.nav.gallery}</Link></li>
            <li><Link to="/about" className="hover:text-mustard transition-colors">{t.nav.about}</Link></li>
            <li><Link to="/educators" className="hover:text-mustard transition-colors">{t.nav.educators}</Link></li>
            <li><Link to="/portal" className="hover:text-mustard transition-colors">{t.nav.portal}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">Visit Us</h4>
          <ul className="space-y-3 text-sm text-cream/80">
            <li className="flex gap-2.5"><MapPin className="h-4 w-4 shrink-0 mt-0.5 text-mustard" />{site.address}</li>
            <li className="flex gap-2.5"><Phone className="h-4 w-4 shrink-0 mt-0.5 text-mustard" /><a href={`tel:${site.phone}`} className="hover:text-mustard">{site.phone}</a></li>
            <li className="flex gap-2.5"><Mail className="h-4 w-4 shrink-0 mt-0.5 text-mustard" /><a href={`mailto:${site.email}`} className="hover:text-mustard">{site.email}</a></li>
            <li className="flex gap-2.5"><Clock className="h-4 w-4 shrink-0 mt-0.5 text-mustard" />{site.hours}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-4">{t.sections.ctaTitle}</h4>
          <p className="text-sm text-cream/70 mb-4">{t.sections.ctaSub}</p>
          <InquiryForm type="tour" trigger={<Button className="rounded-full bg-mustard hover:bg-mustard-dark text-navy font-semibold w-full" data-testid="footer-book-tour-btn">{t.nav.bookTour}</Button>} />
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-xs text-cream/60 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Ainalem Family Childcare. All rights reserved.</span>
          <span>{t.sections.deibTitle}</span>
        </div>
      </div>
    </footer>
  );
}
